import { createSlice } from "@reduxjs/toolkit";
import {
  addAnnouncement,
  getAnnouncements,
  deleteAnnouncement,
  updateAnnouncement,
} from "../apiActions/announcementActions";
import { notification } from "antd";

export type Announcement = {
  id: string;
  title: string;
  message: string;
  type: string;
};

type AnnouncementState = {
  announcements: Announcement[];
  error: null | string;
  loading: {
    getAnnouncement: boolean;
    addAnnouncement: boolean;
    deleteAnnouncement: boolean;
    updateAnnouncement: boolean;
  };
};

const initialState: AnnouncementState = {
  announcements: [],
  error: null,
  loading: {
    getAnnouncement: false,
    addAnnouncement: false,
    deleteAnnouncement: false,
    updateAnnouncement: false,
  },
};

const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnnouncements.pending, (state: AnnouncementState) => {
        state.loading.getAnnouncement = true;
        state.error = null;
      })
      .addCase(
        getAnnouncements.fulfilled,
        (state: AnnouncementState, action) => {
          state.loading.getAnnouncement = false;
          state.error = null;
          state.announcements = action.payload;
        }
      )
      .addCase(
        getAnnouncements.rejected,
        (state: AnnouncementState, action) => {
          state.loading.getAnnouncement = false;
          notification.error(action.payload as any);
        }
      )
      .addCase(addAnnouncement.pending, (state: AnnouncementState) => {
        state.loading.addAnnouncement = true;
        state.error = null;
      })
      .addCase(
        addAnnouncement.fulfilled,
        (state: AnnouncementState, action) => {
          state.loading.addAnnouncement = false;
          state.error = null;
        }
      )
      .addCase(addAnnouncement.rejected, (state: AnnouncementState, action) => {
        state.loading.addAnnouncement = false;
        notification.error(action.payload as any);
      })
      .addCase(deleteAnnouncement.pending, (state: AnnouncementState) => {
        state.loading.deleteAnnouncement = true;
        state.error = null;
      })
      .addCase(
        deleteAnnouncement.fulfilled,
        (state: AnnouncementState, action) => {
          state.loading.deleteAnnouncement = false;
          state.error = null;
        }
      )
      .addCase(
        deleteAnnouncement.rejected,
        (state: AnnouncementState, action) => {
          state.loading.deleteAnnouncement = false;
          notification.error(action.payload as any);
        }
      )
      .addCase(updateAnnouncement.pending, (state: AnnouncementState) => {
        state.loading.updateAnnouncement = true;
        state.error = null;
      })
      .addCase(
        updateAnnouncement.fulfilled,
        (state: AnnouncementState, action) => {
          state.loading.updateAnnouncement = false;
          state.error = null;
        }
      )
      .addCase(
        updateAnnouncement.rejected,
        (state: AnnouncementState, action) => {
          state.loading.updateAnnouncement = false;
          notification.error(action.payload as any);
        }
      );
  },
});

// export const {} = announcementSlice.actions;
export default announcementSlice.reducer;
